import { createEntityAdapter } from "@reduxjs/toolkit";

export const adapter = createEntityAdapter<API.ACHCompany>({
  sortComparer: (a, b) => a.company_name.localeCompare(b.company_name),
});
